import { EnrollCourseMaster } from './EnrollCourseMaster.model';
import { LectureMaster } from './LectureMaster.model';
import { StudentLectureContentMaster } from './StudentLectureContentMaster.model';
import { StudentLectureMcqMaster } from './StudentLectureMcqMaster.model';
import { PredefinedMaster } from './PredefinedMaster.model';
import { AskAQuery } from './AskAQuery.model';

export class StudentLectureMaster{
    public studentLectureMasterId:number;
    public enrollCourseMaster:EnrollCourseMaster;
    public lectureMaster:LectureMaster;
    public studentLectureContentVideosList:StudentLectureContentMaster[];
    public studentLectureContentAssignmentsList:StudentLectureContentMaster[];
    public studentLectureContentNotesList:StudentLectureContentMaster[];
    public studentLectureMcqMasterList:StudentLectureMcqMaster[];
    public lastWatchedVideo:StudentLectureContentMaster;
    public lastWatchedVideoTime:number;
    public lastMcqSolved:StudentLectureMcqMaster;
    public mcqMarks:number;
    public assignmentMarks:number;
    public lectureStatus:PredefinedMaster;
    public lectureMasterTemp:LectureMaster;
    public askAQueryList:AskAQuery[];
    public errorMessage:String;
    public completedPercent:number;
    public hasAssessment:boolean;
  
}